<div>
    <h3>Category Management</h3>
    <div *ngIf="parentIdForNewCategory !== null || parentIdForNewCategory === null" class="input-button-wrapper">
      <input class="form-control search-input" [(ngModel)]="newCategoryName" placeholder="Category name" />
      <button class="btn btn-primary " (click)="saveCategory()" [disabled]="!parentIdForNewCategory || !newCategoryName.trim()"
      >Save</button>
    </div>
    <br/>
    <button class="btn btn-dark" (click)="startAddTopLevel()" [ngClass]="{ 'active': parentIdForNewCategory == null || parentIdForNewCategory < 1 }">+ Add Top Level Category</button>
    <br/>
    <br/>
    <ul class="list-group list-spacing">
      <ng-container *ngFor="let category of categories">
        <li class="list-group-item" [@fadeAnimation]="category.deleted ? 'deleted' : 'active'" [ngClass]="{ 'deleted-category': category.deleted }" >
          <div class="input-button-wrapper">
            <div class="category-name">{{ category.name }}</div>
            <div class="d-flex gap-2">
              <button class="btn btn-outline-secondary" (click)="toggleCategory(category.category_id)">
                {{ expandedCategories.has(category.category_id) ? '− Collapse' : '+ Expand' }}
              </button>
        
              <button 
                class="btn btn-dark" 
                (click)="startAddSubcategory(category.category_id)" 
                [ngClass]="{ 'active': parentIdForNewCategory === category.category_id }">
                + Add Subcategory
              </button>
        
              <button 
                class="btn"
                [ngClass]="category.deleted ? 'btn-success' : 'btn-danger'"
                (click)="category.deleted ? confirmRestoreCategory(category) : confirmDeleteCategory(category)">
                {{ category.deleted ? 'Restore' : 'Delete' }}
              </button>

        
            </div>
          </div>
        
          <div *ngIf="expandedCategories.has(category.category_id)" class="mt-2">
            <app-category-node
              [children]="category.children"
              [parentIdForNewCategory]="parentIdForNewCategory"
              (addSub)="startAddSubcategory($event)"
              (deleteCategoryEvent)="deleteCategory($event)"
              (restoreCategoryEvent)="restoreCategory($event)">
            </app-category-node>
          </div>
        </li>
        
      </ng-container>
    </ul>
    
  </div>
  